const COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;

const PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;

export const NORMAL_EARLY_ASSET_STRATEGY = [VENDOR_ASSET_REGEX, PARCEL_VENDOR_ASSET_REGEX];
export const AGGRESSIVE_EARLY_ASSET_STRATEGY = [
	VENDOR_ASSET_REGEX,
	COMMON_ASSET_REGEX,
	PARCEL_VENDOR_ASSET_REGEX,
	PARCEL_COMMON_ASSET_REGEX,
];
